import { render, staticRenderFns } from "./UnificarFichas.vue?vue&type=template&id=9fd04ef0&scoped=true"
import script from "./UnificarFichas.vue?vue&type=script&lang=js"
export * from "./UnificarFichas.vue?vue&type=script&lang=js"
import style0 from "./UnificarFichas.vue?vue&type=style&index=0&id=9fd04ef0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd04ef0",
  null
  
)

export default component.exports